import { MoreOutlined } from '@ant-design/icons'
import { Styles } from '@types'
import { Button, Dropdown, Menu, Table, TableColumnType, TablePaginationConfig } from 'antd'
import { Additions } from 'gadjet-v2-types/dist/model'
import { Pagination } from 'gadjet-v2-types/dist/type'

import { krw } from '@utils/format'

import { BranchAdditionAction } from '@pages/Authorized/Branch/AdditionPage'

import ContentWrapper from '@components/atoms/ContentWrapper'
import TableColumnItem from '@components/molecules/TableColumn/Item'

type Props = {
  loading: boolean
  total: number
  pagination: Pagination
  additions: Additions[]
  onChangePagination: (pagination: Pagination) => void
  onAction: (action: BranchAdditionAction, addtionId: number) => void
}
export default function BranchAdditionListTable({
  loading,
  total,
  pagination,
  additions,
  onChangePagination,
  onAction,
}: Props): JSX.Element {
  const onChange = (_pagination: TablePaginationConfig) => onChangePagination({ ...pagination, ..._pagination })

  const columns: TableColumnType<Additions>[] = [
    { key: 'name', dataIndex: 'name', title: '이름' },
    {
      key: 'price',
      dataIndex: 'price',
      title: '비용',
      render: (price) => {
        return (
          <>
            <TableColumnItem label="공급가액" value={krw(price)} />
            <TableColumnItem label="부가세" value={krw(price / 10)} />
          </>
        )
      },
    },
    {
      key: 'additionId',
      dataIndex: 'additionId',
      title: '사용 중',
      render: (_, { additionId }) => <Button onClick={() => onAction('contract', additionId)}>계약내역</Button>,
    },
    {
      key: 'additionId',
      dataIndex: 'additionId',
      title: '',
      width: '80px',
      render: (_, { additionId }) => (
        <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="update" onClick={() => onAction('update', additionId)}>
                수정
              </Menu.Item>
              <Menu.Item key="delete" onClick={() => onAction('delete', additionId)}>
                제거
              </Menu.Item>
            </Menu>
          }
          placement="bottomRight"
          trigger={['click']}
        >
          <Button icon={<MoreOutlined />} size="large" type="text" />
        </Dropdown>
      ),
    },
  ]

  return (
    <ContentWrapper>
      <Table<Additions>
        loading={loading}
        style={styles.table}
        scroll={{ x: true }}
        rowKey={({ additionId }) => `${additionId}`}
        dataSource={additions}
        columns={columns}
        onChange={onChange}
        pagination={{
          total,
          position: ['bottomRight'],
          current: pagination.current,
          pageSize: pagination.pageSize,
        }}
      />
    </ContentWrapper>
  )
}

const styles: Styles = {
  table: { whiteSpace: 'pre-wrap', wordBreak: 'keep-all' },
}
